import React, { useState } from 'react';

import PropTypes from 'prop-types';
import PayrollUtils from 'utils/PayrollUtils';
import Select from 'components/widgets/Select';
import { makeStyles } from '@material-ui/core/styles';
import ConfirmDialog from 'components/widgets/modal/ConfirmDialog';

const QUARTER_OPTIONS = [
    { label: 'Quarter 1', value: 1 },
    { label: 'Quarter 2', value: 2 },
    { label: 'Quarter 3', value: 3 },
    { label: 'Quarter 4', value: 4 },
];

const useStyles = makeStyles(() => ({
    content: {
        display: 'flex',
        marginTop: '15px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    yearDropdown: {
        width: 75,
    },
    quarterDropdown: {
        width: 108,
        marginLeft: 10,
    },
}));

const PayrollRT6FormDialog = (props) => {
    const {
        onCloseDialog,
    } = props;
    const classes = useStyles();
    const currentDate = new Date();

    const [state, setState] = useState({
        year: currentDate.getFullYear(),
        quarter: Math.floor(currentDate.getMonth() / 3) + 1,
    });

    const { year, quarter } = state;

    const onChangeYear = (_, value) => {
        setState((prevState) => ({
            ...prevState,
            year: value,
        }));
    };

    const onChangeQuarter = (_, value) => {
        setState((prevState) => ({
            ...prevState,
            quarter: value,
        }));
    };

    return (
        <ConfirmDialog
            open
            variant="outlined"
            titlePrimary="Ok"
            titleSecondary="Cancel"
            onClose={() => onCloseDialog()}
            disablePrimaryButton={!year || !quarter}
            onClickSecondary={() => onCloseDialog()}
            description="Select the year and the quarter."
            onClickPrimary={() => onCloseDialog(year, quarter)}
        >
            <div className={classes.content}>
                <Select
                    size="sm"
                    name="year"
                    value={year}
                    onChange={onChangeYear}
                    placeholder="Select Year"
                    className={classes.yearDropdown}
                    options={PayrollUtils.getYears().map((option) => ({
                        label: option.label - 1,
                        value: option.value - 1,
                    }))}
                />
                <Select
                    size="sm"
                    name="quarter"
                    value={quarter}
                    onChange={onChangeQuarter}
                    placeholder="Select Quarter"
                    options={QUARTER_OPTIONS}
                    className={classes.quarterDropdown}
                />
            </div>
        </ConfirmDialog>
    );
};

PayrollRT6FormDialog.propTypes = {
    onCloseDialog: PropTypes.func.isRequired,
};

export default PayrollRT6FormDialog;
